import { motion } from "framer-motion";
import { OFFICERS } from "@/data/site";

export const Officers = () => {
  return (
    <section
      id="officers"
      className="relative z-10 bg-[#F4EBD9] py-24 lg:py-32"
      data-testid="officers-section"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <p className="text-xs tracking-[0.3em] uppercase font-medium text-[#E07A5F] mb-6">
          Meet the Officers
        </p>
        <h2 className="font-display text-4xl sm:text-5xl font-bold text-[#2B2D42] leading-tight tracking-tight mb-16">
          The students behind Haven For Tails.
        </h2>

        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16">
          {OFFICERS.map((o, i) => (
            <motion.div
              key={o.name}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.7, delay: i * 0.15 }}
              className="flex flex-col sm:flex-row gap-6"
              data-testid={`officer-${o.role.toLowerCase()}`}
            >
              <div className="shrink-0">
                <div className="arch-frame h-40 w-32 shadow-[0_15px_40px_rgba(43,45,66,0.15)]">
                  <img
                    src={o.img}
                    alt={o.name}
                    className="h-full w-full object-cover"
                  />
                </div>
              </div>
              <div>
                <h3 className="font-display text-2xl font-bold text-[#2B2D42]">
                  {o.name}
                </h3>
                <p className="text-sm font-semibold uppercase tracking-wide text-[#E07A5F] mb-4">
                  {o.role}
                </p>
                <p className="text-[#4A4E69] leading-relaxed text-[15px]">
                  {o.bio}
                </p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
